import React from 'react';
import styled from 'styled-components';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { BaseClickable } from '@solvhealth/jigsaw';
import Avatar from '../../../../../Account/Profile/Avatar';
import useToggleRuntimeVariable from '../../../../../../hooks/runtime/useToggleRuntimeVariable';
import { colors } from '../../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../../constants/text';
import { KEY_WITH_SCALE } from '../constants/animatedValues';
import { useProfileBadge } from '../../../../../HeaderV2/components/AccountDrawer/hooks';
import Badge from '../../../../Icons/Badge';
import { isActiveMembership } from '~/core/util/account';
import { profileSupportsMembership } from '~/components/Membership/utils';
import { useAccount } from '~/hooks/account/useAccount';

const Root = styled(BaseClickable)`
  margin: 0 24px 0 auto;
  align-self: center;
  display: flex;
  align-items: center;
  cursor: pointer;

  && .animated {
    animation: ${KEY_WITH_SCALE} 300ms ease;
    animation-fill-mode: both;
    animation-direction: normal;
  }
`;

const Relative = styled.div`
  position: relative;
`;

const Container = styled.div`
  align-self: center;
  display: flex;
  align-items: center;
  transform-origin: right center;
`;

const NameBox = styled.div`
  padding: 0 6px 0 12px;
  color: ${colors.squid};
  font-size: ${fontSize.medium};
  font-family: ${fontFamily.book};
`;

const ChevronDown = styled(ChevronRight)`
  color: ${colors.purpletrator};
  font-size: 12px;
  transform: rotate(${Math.PI / /*🙂 ➡️ 🙃*/ 2}rad);
`;

const ProfileBadge = styled(Badge)`
  height: 14px;
  width: 14px;
  z-index: 1;
  padding: 2px;
`;

type Props = {
  userProfile: any;
};

const ProfileView = (props: Props) => {
  const { userProfile } = props;

  const [, toggleAccountDrawerOpen] = useToggleRuntimeVariable('account-drawer');
  const hasBadge = !!useProfileBadge().length;
  const accountSummary = useAccount();
  const shouldShowMembershipBranding =
    isActiveMembership(accountSummary) && profileSupportsMembership(userProfile);

  return (
    <Root onClick={toggleAccountDrawerOpen}>
      <Container className="to-be-animated">
        <Relative>
          {hasBadge && <ProfileBadge />}

          <Avatar size={40} userProfile={userProfile} />
        </Relative>

        <NameBox>{userProfile && (userProfile.first_name || userProfile.firstName)}</NameBox>
        {shouldShowMembershipBranding && (
          <img src="/images/membership/logo_flat.svg" width="40px" />
        )}
        <ChevronDown />
      </Container>
    </Root>
  );
};

export default ProfileView;
